class CookieConsent {
  constructor() {
    this.el = document.getElementById("cookie-consent");
    this.btn = document.getElementById("cookie-accept");
    if (this.el && this.btn && !localStorage.getItem("cookieAccepted")) {
      this.bindEvents();
      this.el.style.display = "block";
    } else if (this.el) {
      this.el.style.display = "none";
    }
  }

  bindEvents() {
    this.btn.addEventListener("click", () => {
      localStorage.setItem("cookieAccepted", "true");
      this.el.style.display = "none";
    });
  }
}

export default CookieConsent;
